define('TescoMobile_DataLayer/js/datalayer-mutations',['jquery', 'underscore'], function ($, _) {
  'use strict';

  return {
    observers: [],
    targetSelectors: [],
    targets: [],
    configs: [],
    conditions: [],
    eventNames: [],
    lastTriggeredEventIgnore: [],
    lastTriggeredEvent: [],
    flushLastTriggeredEvents: [],
    mutationIndex: [],
    checkEventRegistry: [],
    createObserver: function (dataMutation) {
      var self = this,
        eventData = $.extend(true, {}, dataMutation);
      if (dataMutation.triggerList) {
        _.each(dataMutation.triggerList, function (triggerParams) {
          if (!!triggerParams.onload) {
            $(document).ready(function () {
              var onEvent = {
                data: eventData
              };
              var dataMutationCallbackEventData = self.dataMutationCallback.bind(self, onEvent);
              dataMutationCallbackEventData();
              return;
            });
          }
          eventData.trigger = {};
          eventData.trigger.action = triggerParams.action;
          if (triggerParams.element === 'window') {
            triggerParams.element = window;
          }
          eventData.trigger.element = triggerParams.element;
          if (triggerParams.event === 'one') {
            $(document).one(triggerParams.action, triggerParams.element, eventData, self.dataMutationCallback.bind(self));
          } else {
            $(document).on(triggerParams.action, triggerParams.element, eventData, self.dataMutationCallback.bind(self));
          }
        });
      }
    },
    dataMutationCallback: function (onEvent) {
      var _onEvent$data, _onEvent$data2, _onEvent$data3;
      var self = this,
        dataMutation = onEvent.data,
        triggerAction = (_onEvent$data = onEvent.data) === null || _onEvent$data === void 0 || (_onEvent$data = _onEvent$data.trigger) === null || _onEvent$data === void 0 ? void 0 : _onEvent$data.action,
        triggerElement = (_onEvent$data2 = onEvent.data) === null || _onEvent$data2 === void 0 || (_onEvent$data2 = _onEvent$data2.trigger) === null || _onEvent$data2 === void 0 ? void 0 : _onEvent$data2.element,
        shouldOffAllTriggers = !!((_onEvent$data3 = onEvent.data) !== null && _onEvent$data3 !== void 0 && _onEvent$data3.shouldOffAllTriggers),
        observer,
        target,
        config,
        randomSalt;
      target = document.querySelectorAll(dataMutation.target);
      if (!target.length) {
        return;
      }
      _.each(target, function (targetItem) {
        self.targetSelectors.push(dataMutation.target);
        self.targets.push(targetItem);
        config = $.extend(true, {}, dataMutation.config);
        self.configs.push(config);
        self.conditions.push($.extend(true, {}, dataMutation.conditions));
        self.eventNames.push(dataMutation.triggerEvent + '.' + self.getRandomSalt());
        self.lastTriggeredEventIgnore.push(!!dataMutation.lastTriggeredEventIgnore);
        self.flushLastTriggeredEvents.push(!!dataMutation.flushLastTriggeredEvents);
        self.checkEventRegistry.push(!!dataMutation.checkEventRegistry);
        observer = new MutationObserver(self.subscribe.bind(self));
        observer.observe(targetItem, config);
        self.observers.push(observer);
      });
      if (shouldOffAllTriggers) {
        _.each(dataMutation.triggerList, function (triggerParams) {
          if (triggerParams.element === 'window') {
            triggerParams.element = window;
          }
          $(document).off(triggerParams.action, triggerParams.element);
        });
      } else {
        if (triggerAction && triggerElement) {
          $(document).off(triggerAction, triggerElement);
        }
      }
    },
    subscribe: function (mutations) {
      var self = this;
      mutations.forEach(function (mutation) {
        if (!self.mutationIndex.length) {
          self.mutationCallback(mutation, self);
        }
      });
      self.triggerEvent();
    },
    mutationCallback: function (mutation, self) {
      switch (mutation.type) {
        case 'childList':
          self.childListMutationCallback(mutation, self);
          break;
        case 'attributes':
          self.attributesMutationCallback(mutation, self);
          break;
      }
    },
    childListMutationCallback: function (mutation, self) {
      var property;
      if (!self.conditions.length) {
        return;
      }
      _.each(self.conditions, function (conditionsBunch, index) {
        _.each(conditionsBunch, function (condition) {
          var _self$targets$index, _mutation$target;
          if (condition.target === self.targetSelectors[index] && mutation.type === condition.mutationType && (!self.targets[index].id || !mutation.target.id || !!((_self$targets$index = self.targets[index]) !== null && _self$targets$index !== void 0 && _self$targets$index.id) && !!((_mutation$target = mutation.target) !== null && _mutation$target !== void 0 && _mutation$target.id) && self.targets[index].id === mutation.target.id)) {
            if (mutation[condition.type] && (mutation[condition.type].length || typeof mutation[condition.type] !== 'undefined')) {
              _.each(mutation[condition.type], function (node) {
                if (-1 !== self.mutationIndex.indexOf(index) || !node[condition.property]) {
                  return;
                }
                if (condition.propertyKey) {
                  if (!node[condition.property][condition.propertyKey]) {
                    return;
                  }
                  property = node[condition.property][condition.propertyKey];
                  self.checkProperty(property, condition, mutation, index, self);
                  return;
                }
                property = node[condition.property];
                self.checkProperty(property, condition, mutation, index, self);
              });
            }
          }
        });
      });
    },
    attributesMutationCallback: function (mutation, self) {
      var property, attribute;
      if (!self.conditions.length) {
        return;
      }
      _.each(self.conditions, function (conditionsBunch, index) {
        _.each(conditionsBunch, function (condition) {
          var _self$targets$index2, _mutation$target2;
          if (-1 !== self.mutationIndex.indexOf(index)) {
            return;
          }
          if (condition.target === self.targetSelectors[index] && mutation.type === condition.mutationType && (!self.targets[index].id || !mutation.target.id || !!((_self$targets$index2 = self.targets[index]) !== null && _self$targets$index2 !== void 0 && _self$targets$index2.id) && !!((_mutation$target2 = mutation.target) !== null && _mutation$target2 !== void 0 && _mutation$target2.id) && self.targets[index].id === mutation.target.id)) {
            if (mutation[condition.type][condition.property]) {
              attribute = mutation[condition.type][condition.property];
              property = condition.propertyKey ? attribute[condition.propertyKey] : attribute;
              self.checkProperty(property, condition, mutation, index, self);
            }
          }
        });
      });
    },
    triggerEvent: function () {
      var self = this,
        backendEventNames,
        eventName;
      if (self.mutationIndex.length) {
        _.each(self.mutationIndex, function (index) {
          if (!!self.flushLastTriggeredEvents[index]) {
            self.lastTriggeredEvent = [];
          }
          if (-1 === self.lastTriggeredEvent.indexOf(self.eventNames[index])) {
            backendEventNames = self.eventNames[index].split('.');
            backendEventNames.pop();
            eventName = backendEventNames.join('.');
            $(self.targetSelectors[index]).trigger(eventName);
            if (!self.lastTriggeredEventIgnore[index]) {
              self.lastTriggeredEvent.push(self.eventNames[index]);
            }
          }
        });
        self.mutationIndex = [];
      }
    },
    checkCondition: function (property, value, conditionType) {
      if ((!!property || property === '') && (!!value || value === '')) {
        switch (conditionType) {
          case 'eq':
            return property === value;
          case 'in':
            return property.indexOf(value) !== -1;
        }
      }
      return false;
    },
    getConditionExtraProperty: function (property, extraProperty) {
      if (Array.isArray(extraProperty)) {
        _.each(extraProperty, function (extra) {
          if (property && property[extra]) {
            property = property[extra];
          }
        });
        return property;
      }
      return !!extraProperty ? property[extraProperty] : property;
    },
    checkProperty: function (property, condition, mutation, index, self) {
      var shouldTrigger;
      property = self.getConditionExtraProperty(property, condition.extraProperty);
      if (!!property || property === '') {
        if (!!condition.oldValue) {
          if (!mutation.oldValue || mutation.oldValue !== condition.oldValue) {
            return;
          }
        }
        shouldTrigger = self.checkCondition(property, condition.value, condition.conditionType);
        if (shouldTrigger && !!self.checkEventRegistry[index]) {
          var targetHtmlHash = forge_sha256(mutation.target.innerHTML),
            eventRegistry = !!$.data(document.body, 'eventRegistry') ? $.data(document.body, 'eventRegistry') : [];
          if (-1 !== eventRegistry.indexOf(targetHtmlHash)) {
            shouldTrigger = false;
          } else {
            eventRegistry.push(targetHtmlHash);
            $.data(document.body, 'eventRegistry', eventRegistry);
          }
        }
        if (shouldTrigger) {
          self.mutationIndex.push(index);
        }
      }
    },
    getRandomSalt: function () {
      var _$$data;
      var randomSalt = forge_sha256(Date.now() + this.getRandomInt(0, 88888)),
        saltRegistry = (_$$data = $.data(document.body, 'eventSaltRegistry')) !== null && _$$data !== void 0 ? _$$data : [];
      if (-1 !== saltRegistry.indexOf(randomSalt)) {
        randomSalt = this.getRandomSalt();
      }
      if (-1 === saltRegistry.indexOf(randomSalt)) {
        saltRegistry.push(randomSalt);
      }
      $.data(document.body, 'eventSaltRegistry', saltRegistry);
      return randomSalt;
    },
    getRandomInt: function (min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min;
    }
  };
});

